const customRadio = () => {
  let $radio =  $('.custom-js-radio')

  $radio.on('click', function () {
    let ths = $(this)
    let parent = ths.parents('.custom-js-radio-list')

    parent.find($radio).removeClass('is-checked')
    ths.addClass('is-checked')
  })
}

export default customRadio;